__turbopack_context__.v({
  "background": "styles-module-scss-module__99FI7a__background",
  "bgFirst": "styles-module-scss-module__99FI7a__bgFirst",
  "bgSecond": "styles-module-scss-module__99FI7a__bgSecond",
  "bgThird": "styles-module-scss-module__99FI7a__bgThird",
  "circle": "styles-module-scss-module__99FI7a__circle",
  "circleDarkMode": "styles-module-scss-module__99FI7a__circleDarkMode",
  "circleFirst": "styles-module-scss-module__99FI7a__circleFirst",
  "circleFirstDarkMode": "styles-module-scss-module__99FI7a__circleFirstDarkMode",
  "circleSecond": "styles-module-scss-module__99FI7a__circleSecond",
  "circleSecondDarkMode": "styles-module-scss-module__99FI7a__circleSecondDarkMode",
  "circleThird": "styles-module-scss-module__99FI7a__circleThird",
  "circleThirdDarkMode": "styles-module-scss-module__99FI7a__circleThirdDarkMode",
  "container": "styles-module-scss-module__99FI7a__container",
  "containerDarkMode": "styles-module-scss-module__99FI7a__containerDarkMode",
  "root": "styles-module-scss-module__99FI7a__root",
  "stepNumber": "styles-module-scss-module__99FI7a__stepNumber",
  "text": "styles-module-scss-module__99FI7a__text",
  "title": "styles-module-scss-module__99FI7a__title",
  "titleFirst": "styles-module-scss-module__99FI7a__titleFirst",
});
